export * from './aggregatorRouteImplementation.service';
import { AggregatorRouteImplementationService } from './aggregatorRouteImplementation.service';
export * from './platformResources.service';
import { PlatformResourcesService } from './platformResources.service';
export * from './platformSubscription.service';
import { PlatformSubscriptionService } from './platformSubscription.service';
export * from './rcsAgents.service';
import { RcsAgentsService } from './rcsAgents.service';
export * from './routeCreation.service';
import { RouteCreationService } from './routeCreation.service';
export * from './routeCredentails.service';
import { RouteCredentailsService } from './routeCredentails.service';
export * from './routeGroup.service';
import { RouteGroupService } from './routeGroup.service';
export * from './routeMap.service';
import { RouteMapService } from './routeMap.service';
export * from './sMPPClientCredential.service';
import { SMPPClientCredentialService } from './sMPPClientCredential.service';
export * from './sMPPConnections.service';
import { SMPPConnectionsService } from './sMPPConnections.service';
export const APIS = [AggregatorRouteImplementationService, PlatformResourcesService, PlatformSubscriptionService, RcsAgentsService, RouteCreationService, RouteCredentailsService, RouteGroupService, RouteMapService, SMPPClientCredentialService, SMPPConnectionsService];
